module.exports = __webpack_public_path__ + "media/images/features/draft/heading-mv-subtitle-8e848cb921f5def5308f9f92a4409c88.svg";